import React, {memo} from 'react';
import {useLocalizer} from '@/common/services/localizer';
import {useRoute} from '@/common/services/router';
import {useUrlBuilder} from '@/app/routing/useUrlBuilder';
import {RouteName} from '@/app/constants/routing';
import {AnyRouteResult} from '@/app/interfaces/routing';
import {SearchField} from '@/app/components/desktop/misc/search';
import {RecentLocations} from '@/app/components/desktop/misc/RecentLocations';
import {SettingsButton} from '@/app/components/desktop/misc/settings';
import {RouterLink} from '@/common/components/RouterLink';
import styles from './AppHeader.css';

export const AppHeader = memo(() => {
	const t = useLocalizer();
	const {route, history} = useRoute<AnyRouteResult>();
	const urlBuilder = useUrlBuilder();
	const mainPageUrl = urlBuilder(RouteName.mainPage, {});

	const handleNavigateToMain = () => {
		history!.replace(mainPageUrl);
	};

	return (
		<header className={styles.root}>
			{/* Used a div instead a href due a SEO requirements */}
			{route.name === RouteName.mainPage ? (
				<div className={styles.logo} onClick={handleNavigateToMain} />
			) : (
				<RouterLink className={styles.logo} url={mainPageUrl} aria-label={t('mainPageLabel')} />
			)}
			<div className={styles.main}>
				<SearchField />
				<RecentLocations />
			</div>
			<SettingsButton />
		</header>
	);
});

AppHeader.displayName = 'AppHeader';
